import { render } from "./ReformSubmitJudges.vue?vue&type=template&id=56a6ffc4&scoped=true"
import script from "./ReformSubmitJudges.vue?vue&type=script&lang=js"
export * from "./ReformSubmitJudges.vue?vue&type=script&lang=js"

import "./ReformSubmitJudges.vue?vue&type=style&index=0&id=56a6ffc4&scoped=true&lang=css"

import exportComponent from "D:\\pro\\edu-hsd\\cxcj\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a6ffc4"]])

export default __exports__